"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageField = void 0;
const react_1 = __importStar(require("react"));
const ImageField = ({ field, value, onChange, error, disabled }) => {
    const inputRef = (0, react_1.useRef)(null);
    const handleFileChange = (0, react_1.useCallback)((e) => {
        const file = e.target.files?.[0];
        if (!file)
            return;
        const reader = new FileReader();
        reader.onloadend = () => {
            onChange(field.key, reader.result);
        };
        reader.readAsDataURL(file);
    }, [field.key, onChange]);
    if (value && typeof value === 'string' && value.startsWith('data:image')) {
        return (react_1.default.createElement("div", { className: "field-group" },
            react_1.default.createElement("label", { className: "field-label" },
                field.label,
                field.required && react_1.default.createElement("span", { className: "required" }, "*")),
            react_1.default.createElement("div", { className: "photo-preview" },
                react_1.default.createElement("img", { src: value, alt: "Preview" })),
            !disabled && (react_1.default.createElement("button", { type: "button", className: "wf-btn-remove", style: { marginTop: 8, alignSelf: 'flex-start' }, onClick: () => onChange(field.key, null) }, "Remove"))));
    }
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label" },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        react_1.default.createElement("div", { className: "photo-upload", onClick: () => !disabled && inputRef.current?.click() },
            react_1.default.createElement("input", { ref: inputRef, type: "file", accept: "image/*", onChange: handleFileChange, disabled: disabled, style: { position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' } }),
            react_1.default.createElement("div", { className: "photo-upload-icon" }, '\u{1F4F7}'),
            react_1.default.createElement("div", { className: "photo-upload-text" }, "Click to upload photo"),
            react_1.default.createElement("div", { className: "photo-upload-hint" }, "Passport size, .png / .jpg / .jpeg")),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.ImageField = ImageField;
